import { TCollectionIcons } from '@/types';

const truffleKitIcons: TCollectionIcons = {
  showPassword: `
    <svg
      data-test-id="show-password"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6852 11.6953C23.6523 11.6212 22.8584 9.86005 21.0927 8.09436C18.7411 5.74246 15.7696 4.49924 12.4999 4.49924C9.23018 4.49924 6.25868 5.74236 3.90705 8.09427C2.14136 9.86005 1.34739 11.6213 1.31449 11.6954C1.27189 11.7913 1.24988 11.8951 1.24988 12C1.24988 12.1049 1.27189 12.2087 1.31449 12.3046C1.34749 12.3786 2.14136 14.1395 3.90714 15.905C6.25877 18.2563 9.23008 19.4992 12.4999 19.4992C15.7697 19.4992 18.741 18.2563 21.0926 15.905C22.8583 14.1395 23.6523 12.3787 23.6853 12.3046C23.7279 12.2087 23.7499 12.1049 23.7499 12C23.7499 11.8951 23.7279 11.7913 23.6853 11.6954L23.6852 11.6953ZM12.4999 17.9993C9.61427 17.9993 7.09296 16.9506 5.00599 14.8825C4.1483 14.0313 3.41845 13.0604 2.83914 12C3.41842 10.9393 4.14828 9.96819 5.00599 9.1168C7.09296 7.04811 9.61436 5.99924 12.4999 5.99924C15.3854 5.99924 17.9068 7.04811 19.9938 9.1168C20.8516 9.96817 21.5815 10.9393 22.1607 12C21.4845 13.2609 18.5404 17.9991 12.4999 17.9991V17.9993ZM12.4999 7.49999C11.6099 7.49999 10.7398 7.76391 9.99983 8.25837C9.25981 8.75284 8.68303 9.45564 8.34244 10.2779C8.00184 11.1002 7.91273 12.005 8.08636 12.8779C8.25999 13.7508 8.68858 14.5526 9.31791 15.182C9.94725 15.8113 10.7491 16.2399 11.622 16.4135C12.4949 16.5872 13.3997 16.498 14.222 16.1574C15.0442 15.8169 15.747 15.2401 16.2415 14.5001C16.736 13.76 16.9999 12.89 16.9999 12C16.9986 10.8069 16.524 9.66311 15.6804 8.81949C14.8368 7.97586 13.693 7.50133 12.4999 7.49999ZM12.4999 15C11.9066 15 11.3265 14.824 10.8332 14.4944C10.3398 14.1648 9.95532 13.6962 9.72826 13.148C9.50119 12.5999 9.44178 11.9967 9.55754 11.4147C9.67329 10.8328 9.95902 10.2982 10.3786 9.87867C10.7981 9.45911 11.3327 9.17339 11.9146 9.05763C12.4966 8.94188 13.0998 9.00129 13.6479 9.22835C14.1961 9.45541 14.6647 9.83993 14.9943 10.3333C15.3239 10.8266 15.4999 11.4066 15.4999 12C15.499 12.7954 15.1826 13.5579 14.6202 14.1203C14.0578 14.6827 13.2953 14.9991 12.4999 15Z"
        fill="#686F90"
      />
    </svg>`,
  hidePassword: `
    <svg
      data-test-id="hide-password"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1458 15.2637C22.1958 15.3491 22.2285 15.4434 22.2419 15.5414C22.2553 15.6394 22.2492 15.7391 22.2239 15.8347C22.1986 15.9304 22.1547 16.02 22.0946 16.0986C22.0345 16.1772 21.9595 16.2431 21.8738 16.2925C21.7882 16.342 21.6936 16.374 21.5955 16.3868C21.4974 16.3995 21.3978 16.3927 21.3023 16.3668C21.2068 16.3409 21.1175 16.2964 21.0393 16.2358C20.9611 16.1752 20.8957 16.0997 20.8468 16.0137L19.1235 13.0288C18.1082 13.7088 16.9916 14.2239 15.8153 14.5549L16.3602 17.6453C16.3947 17.8412 16.35 18.0428 16.2359 18.2058C16.1218 18.3687 15.9477 18.4797 15.7518 18.5142C15.7085 18.5218 15.6646 18.5256 15.6206 18.5257C15.4445 18.5254 15.274 18.4632 15.1392 18.3499C15.0043 18.2366 14.9136 18.0794 14.8829 17.906L14.3468 14.8659C13.1194 15.0452 11.8723 15.0447 10.6449 14.8645L10.1089 17.9046C10.0783 18.0781 9.98759 18.2353 9.85271 18.3486C9.71782 18.462 9.54735 18.5243 9.37116 18.5245C9.32722 18.5245 9.28337 18.5207 9.2401 18.5131C9.0442 18.4786 8.87005 18.3676 8.75594 18.2047C8.64184 18.0417 8.59714 17.8401 8.63166 17.6442L9.17672 14.5525C8.00177 14.221 6.8866 13.7058 5.8725 13.0261L4.13907 16.0285C4.09049 16.1151 4.02521 16.1912 3.94702 16.2523C3.86882 16.3135 3.77926 16.3585 3.68353 16.3848C3.58781 16.4111 3.48781 16.4181 3.38935 16.4054C3.29089 16.3928 3.19593 16.3607 3.10996 16.3111C3.02399 16.2614 2.94873 16.1952 2.88854 16.1163C2.82836 16.0373 2.78445 15.9472 2.75935 15.8512C2.73425 15.7551 2.72847 15.655 2.74234 15.5567C2.75622 15.4585 2.78946 15.3639 2.84016 15.2785L4.668 12.1126C4.03048 11.5639 3.44424 10.9583 2.91657 10.3033C2.85381 10.2268 2.80681 10.1386 2.77829 10.0439C2.74977 9.9491 2.74028 9.84963 2.75038 9.75119C2.76047 9.65274 2.78995 9.55727 2.83711 9.47027C2.88428 9.38327 2.94819 9.30646 3.02517 9.24428C3.10215 9.18209 3.19068 9.13575 3.28565 9.10794C3.38062 9.08012 3.48016 9.07137 3.57853 9.0822C3.67689 9.09303 3.77214 9.12322 3.85879 9.17102C3.94544 9.21883 4.02177 9.28332 4.08338 9.36076C4.66905 10.0896 5.33744 10.7478 6.0751 11.3223C6.081 11.3264 6.08635 11.3311 6.09207 11.3354C7.92253 12.7595 10.181 13.5224 12.5001 13.5C14.8186 13.5224 17.0764 12.7598 18.9067 11.3364C18.9116 11.3326 18.9162 11.3288 18.9213 11.3251C19.6604 10.75 20.33 10.0907 20.9167 9.36076C21.0422 9.20771 21.2231 9.11049 21.42 9.09029C21.617 9.0701 21.8139 9.12857 21.9679 9.25296C22.1218 9.37734 22.2204 9.55756 22.2421 9.75432C22.2637 9.95108 22.2067 10.1484 22.0835 10.3033C21.5547 10.9596 20.9673 11.5663 20.3283 12.1158L22.1458 15.2637Z"
        fill="#686F90"
      />
    </svg>`,
  delete: `
    <svg
      class="ml-2"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 3.38889H13L12.1429 2.5H7.85714L7 3.38889H4V5.16667H16V3.38889ZM4.85714 16.7222C4.85714 17.1937 5.03775 17.6459 5.35925 17.9793C5.68074 18.3127 6.11677 18.5 6.57143 18.5H13.4286C13.8832 18.5 14.3193 18.3127 14.6408 17.9793C14.9622 17.6459 15.1429 17.1937 15.1429 16.7222V6.05556H4.85714V16.7222Z"
        fill="#64A2FF"
      />
    </svg>`,
  menuPfofile: `
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2013_34097)">
      <path d="M7.5 1C8.49456 1 9.44839 1.39509 10.1517 2.09835C10.8549 2.80161 11.25 3.75544 11.25 4.75C11.25 5.74456 10.8549 6.69839 10.1517 7.40165C9.44839 8.10491 8.49456 8.5 7.5 8.5C6.50544 8.5 5.55161 8.10491 4.84835 7.40165C4.14509 6.69839 3.75 5.74456 3.75 4.75C3.75 3.75544 4.14509 2.80161 4.84835 2.09835C5.55161 1.39509 6.50544 1 7.5 1ZM7.5 10.375C11.6438 10.375 15 12.0531 15 14.125V16H0V14.125C0 12.0531 3.35625 10.375 7.5 10.375Z" fill="#686F90"/>
      </g>
      <defs>
      <clipPath id="clip0_2013_34097">
      <rect width="15" height="15" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
      </defs>
    </svg>
  `,
  menuSettings: `
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5017 12.125C8.78598 12.125 8.09957 11.8484 7.59348 11.3562C7.08738 10.8639 6.80306 10.1962 6.80306 9.5C6.80306 8.80381 7.08738 8.13613 7.59348 7.64384C8.09957 7.15156 8.78598 6.875 9.5017 6.875C10.2174 6.875 10.9038 7.15156 11.4099 7.64384C11.916 8.13613 12.2003 8.80381 12.2003 9.5C12.2003 10.1962 11.916 10.8639 11.4099 11.3562C10.9038 11.8484 10.2174 12.125 9.5017 12.125ZM15.2305 10.2275C15.2614 9.9875 15.2845 9.7475 15.2845 9.5C15.2845 9.2525 15.2614 9.005 15.2305 8.75L16.8574 7.5275C17.0039 7.415 17.0425 7.2125 16.9499 7.0475L15.4079 4.4525C15.3153 4.2875 15.1072 4.22 14.9375 4.2875L13.0176 5.0375C12.6167 4.745 12.2003 4.49 11.7146 4.3025L11.4293 2.315C11.3985 2.135 11.2365 2 11.0438 2H7.95962C7.76686 2 7.60494 2.135 7.5741 2.315L7.28882 4.3025C6.80306 4.49 6.3867 4.745 5.98576 5.0375L4.06587 4.2875C3.89624 4.22 3.68806 4.2875 3.59554 4.4525L2.05346 7.0475C1.95322 7.2125 1.99948 7.415 2.14598 7.5275L3.77288 8.75C3.74203 9.005 3.7189 9.2525 3.7189 9.5C3.7189 9.7475 3.74203 9.9875 3.77288 10.2275L2.14598 11.4725C1.99948 11.585 1.95322 11.7875 2.05346 11.9525L3.59554 14.5475C3.68806 14.7125 3.89624 14.7725 4.06587 14.7125L5.98576 13.955C6.3867 14.255 6.80306 14.51 7.28882 14.6975L7.5741 16.685C7.60494 16.865 7.76686 17 7.95962 17H11.0438C11.2365 17 11.3985 16.865 11.4293 16.685L11.7146 14.6975C12.2003 14.5025 12.6167 14.255 13.0176 13.955L14.9375 14.7125C15.1072 14.7725 15.3153 14.7125 15.4079 14.5475L16.9499 11.9525C17.0425 11.7875 17.0039 11.585 16.8574 11.4725L15.2305 10.2275Z" fill="#686F90"/>
    </svg>
  `,
  menuBilling: `
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.92141 7.9C7.46857 7.31 6.67976 6.7 6.67976 5.75C6.67976 4.66 7.77112 3.9 9.59725 3.9C11.5206 3.9 12.2338 4.75 12.2986 6H14.6866C14.611 4.28 13.4764 2.7 11.2181 2.19V0H7.97642V2.16C5.88016 2.58 4.1945 3.84 4.1945 5.77C4.1945 8.08 6.25835 9.23 9.27308 9.9C11.9745 10.5 12.5147 11.38 12.5147 12.31C12.5147 13 11.9853 14.1 9.59725 14.1C7.37132 14.1 6.49607 13.18 6.3556 12H4C4.12967 14.19 5.90177 15.42 7.97642 15.83V18H11.2181V15.85C13.3251 15.5 15 14.35 15 12.3C15 9.46 12.3743 8.5 9.92141 7.9Z" fill="#686F90"/>
    </svg>
  `,
  menuLogout: `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 4.16667C2.5 3.25 3.25 2.5 4.16667 2.5H10.8333V4.16667H4.16667V15.8333H10.8333V17.5H4.16667C3.25 17.5 2.5 16.75 2.5 15.8333V4.16667ZM14.3133 9.16667L12.2 7.05333L13.3783 5.875L17.5033 10L13.3783 14.125L12.2 12.9467L14.3133 10.8333H8.825V9.16667H14.3133Z" fill="#686F90"/>
    </svg>
  `,
  downloadIcon: `
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 30H27V27.6471H12V30ZM27 17.0588H22.7143V10H16.2857V17.0588H12L19.5 25.2941L27 17.0588Z" fill="#686B6F"/>
  </svg>
  `,
  deleteIcon: `
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.583 2.66661H13.3955L12.4848 1.74994H7.93122L7.02051 2.66661H3.83301V4.49994H16.583V2.66661ZM4.74372 16.4166C4.74372 16.9028 4.93562 17.3691 5.27721 17.713C5.61879 18.0568 6.08208 18.2499 6.56515 18.2499H13.8509C14.3339 18.2499 14.7972 18.0568 15.1388 17.713C15.4804 17.3691 15.6723 16.9028 15.6723 16.4166V5.41661H4.74372V16.4166Z"
        fill="#868CAC"
      />
    </svg> 
  `,
  selectAllIcon: `
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 1.74845e-07C0.895431 1.74845e-07 0 0.895431 0 2V10H3V3H10V1.74845e-07H2Z"
        fill="#D4D7E8"
      />
      <path
        d="M22 2C22 0.895431 21.1046 1.59189e-07 20 1.39876e-07L12 0V3H19V10H22V2Z"
        fill="#D4D7E8"
      />
      <path
        d="M2 22C0.895431 22 0 21.1046 0 20L0 12H3V19H10V22H2Z"
        fill="#D4D7E8"
      />
      <path
        d="M22 20C22 21.1046 21.1046 22 20 22H12V19H19V12H22V20Z"
        fill="#D4D7E8"
      />
    </svg>
  `,
  goBack: `
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1765 15.3235L5.82353 9.49996L12.1765 3.67643"
        stroke="black"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  `,
};

export default truffleKitIcons;
